import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
    return (
        <footer id="contact" className="bg-[#050505] pt-20 pb-12 px-6 md:px-12 text-[#fbfbf4] relative overflow-hidden">
            <div className="flex flex-col md:flex-row justify-between gap-12 mb-20">
                <div className="flex gap-20">
                    <div className="space-y-4">
                        <h6 className="text-xs uppercase tracking-[0.2em] opacity-40 mb-6">Site Index</h6>
                        {['Home', 'Work', 'About', 'Services', 'Privacy'].map(link => (
                            <a key={link} href={`#${link.toLowerCase()}`} className="block hover:opacity-50 transition-opacity text-sm">{link}</a>
                        ))}
                    </div>

                    <div className="space-y-4">
                        <h6 className="text-xs uppercase tracking-[0.2em] opacity-40 mb-6">Social</h6>
                        <a href="https://instagram.com/zxenxi" target="_blank" rel="noopener noreferrer" className="block hover:opacity-50 transition-opacity text-sm">Instagram</a>
                    </div>
                </div>

                <div className="md:w-1/3">
                    <div className="bg-[#111] p-8 rounded-sm border border-white/10">
                        <p className="font-migra text-2xl mb-6">Tell me about your project. <br /> Let's collaborate.</p>
                        <div className="space-y-4 mb-8">
                            <a href="mailto:falfatoni@gmail.com" className="block text-xl border-b border-white/20 pb-2 hover:border-white transition-colors">falfatoni@gmail.com</a>
                        </div>
                        <div className="relative">
                            <input type="email" placeholder="Subscribe to newsletter" className="w-full bg-transparent border-b border-white/20 py-3 text-sm focus:outline-none focus:border-white transition-colors" />
                            <button className="absolute right-0 top-3 text-xs uppercase tracking-widest font-bold">Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* FOOTER REVEAL TEXT */}
            <div className="border-t border-white/10 pt-12">
                <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                >
                    <svg viewBox="0 0 1362 178" fill="white" className="w-full h-auto opacity-90 hover:opacity-100 transition-opacity duration-700">
                        <text x="50%" y="130" fontSize="150" fontFamily="serif" textAnchor="middle" fill="white" className="font-migra italic">zxenxi.</text>
                    </svg>
                </motion.div>
            </div>

            <div className="flex justify-between mt-8 text-[10px] uppercase tracking-[0.2em] opacity-40">
                <span>© 2026 zxenxi</span>
                <span>Independent Practice</span>
                <span>Authority & Legacy</span>
            </div>
        </footer>
    );
};

export default Footer;
